import ConnectedIntegrationsView from './ChatTextbox.ConnectedIntegrations.View';
import useAIAgent from 'components/AIAgent/useAIAgent';

const ConnectedIntegrations = () => {
  const { integrations } = useAIAgent();

  return <ConnectedIntegrationsView integrations={integrations} />;
};

export default ConnectedIntegrations;
